import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {ArtworkGuidelineModel} from "../models/domain/artworkGuidelineModel";

export const useCustomerArtworkQuery = () => {
    const {model: {id, artworkGuidelineType, artworkGuidelineTypeId, isDesignerProduct}} = useProductDetailsQuery();
    return {model: new ArtworkGuidelineModel(artworkGuidelineType, artworkGuidelineTypeId, isDesignerProduct, id)}
}